import React from 'react';
import $ from 'jquery';
import uniqueId from 'lodash/uniqueId';
import I18n from 'app/i18n';
import {configStore} from 'app/store/global';
import {getImageDomain} from 'app/utils';
import {enableEscPopupClose, preventEscPopupClose} from 'app/utils/modals/popups';
import {showPopup} from 'app/utils/modals/ModalsService';
import {ModalConfirm} from 'app/utils/modals/ModalConfirm';
import {CountryRestriction, showsAvailableActivities} from 'app/utils/countryRestrictions';

const restrictionText = ({key, age}: CountryRestriction): string => I18n.t(`country_restrictions.${key}`, {age});

const renderRestriction = (restriction: CountryRestriction): React.ReactElement => <li key={restriction.key}>
    {restrictionText(restriction)}
</li>;

const CountryRestrictionsContent = ({countryCode, restrictions}: {
    countryCode: string
    restrictions: CountryRestriction[]
}): React.ReactElement => {
    const flag = configStore.REG_FLAGS.find(item => item.code === countryCode);

    return <div className="country-restrictions">
        <div className="country-restrictions__title">{I18n.t('country_restrictions.title')}</div>
        {flag && <div className="country-restrictions__country">
            <img className="country-select-picker-image" src={getImageDomain(false) + flag.image} alt=""/>
            {flag.name}
        </div>}
        <p>{I18n.t('country_restrictions.intro')}</p>
        <ul className="country-restrictions__list">{restrictions.map(renderRestriction)}</ul>
        {showsAvailableActivities(restrictions) && <p>{I18n.t('country_restrictions.available')}</p>}
        <p className="country-restrictions__note">{I18n.t('country_restrictions.note')}</p>
    </div>;
};

export const askAboutCountryRestrictions = (
    countryCode: string,
    restrictions: CountryRestriction[]
): Promise<boolean> => new Promise(resolve => {
    const escWasBlocked = Boolean($('body').data('no-close-popup'));

    const finish = (confirmed: boolean) => (): void => {
        if (!escWasBlocked) {
            enableEscPopupClose();
        }
        resolve(confirmed);
    };

    preventEscPopupClose();
    showPopup(uniqueId('country-restrictions-'), props => <ModalConfirm
        popupId={props.popupId}
        okClick={finish(true)}
        cancelClick={finish(false)}
        okText={I18n.t('country_restrictions.continue')}
        cancelText={I18n.t('country_restrictions.choose_another')}
        classNameModal="popup__content--country-restrictions"
        hideCloseButton
    >
        <CountryRestrictionsContent countryCode={countryCode} restrictions={restrictions}/>
    </ModalConfirm>);
});
